import Icon from '../components/Icon.vue'

Icon.register({
  cocktail: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M296 464c22.1 0 40 17.9 40 40 0 4.4-3.6 8-8 8h-240c-4.4 0-8-3.6-8-8 0-22.1 17.9-40 40-40h56v-125.2l-168.7-168.7c-15.5-15.5-4.5-42 17.4-42h366.6c21.9 0 32.9 26.5 17.4 42l-168.7 168.7v125.2h56zM432 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c-27.4 0-52.8-8.1-74.6-21.4l35.3-35.3c12 5.4 25.3 8.6 39.3 8.6 52.9 0 96-43.1 96-96s-43.1-96-96-96c-35.4 0-66 19.5-82.6 48h-52.5c19.8-55.8 72.6-96 135.2-96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/cocktail.js
// module id = 1162
// module chunks = 0